import { initialSimChoiceState, SimChoiceInterfaceState } from '../state/sim-choice.state';
import { ESimChoiceActions, SimChoiceActions } from '../actions/sim-choice.actions';

export function simChoiceReducer(state: SimChoiceInterfaceState = initialSimChoiceState, action: SimChoiceActions): SimChoiceInterfaceState {
  switch (action.type) {
    case ESimChoiceActions.UpdateSimChoice: {
      return { ...state, simChoice: action.payload };
    }

    default:
      return initialSimChoiceState;
  }
};
